import React, { useEffect, useState } from "react";
import { Card, Col, Row, Table } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import { Stepper } from "./Stepper";
import { t } from "i18next";
import { useLocation } from "react-router";
import { ProductsService } from "../../service";
import { IProducts } from "../../dto/IProducts";
import { ErrorToast, SuccessToast } from "../../../../shared/toasters/toasters";
import { ProductsListView } from "../../components/ProductsListView";
import { formatDate } from "../../../../shared/functions/Functions";
import { CustomImageHandler } from "../../../../shared/components/CustomImageHandler";

export const StepAll = () => {
  const location: any = useLocation();
  const checkedValues = location?.state?.checkedValues || [];
  const [products, setProducts] = useState<IProducts[]>();
  const [product, setProduct] = useState<IProducts>();
  const selectedProducts = JSON.parse(
    localStorage.getItem("selectedProducts") as string
  );
  const selectChangeHandler = (selectedProduct: IProducts) => {
    setProduct(selectedProduct);
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    const filteredArray = selectedProducts?.filter(
      (item: number) => item != product?.id
    );
    ProductsService.copyManage({
      fromProduct: product?.id,
      toProducts: filteredArray,
    })
      .then((response) => {
        SuccessToast(`${t("toasts.successfully_added")}`);
      })
      .catch((error) => ErrorToast(error));
  };
  useEffect(() => {
    if (selectedProducts?.length > 1) {
      const checkedValuesAsStrings = selectedProducts.map(String);
      ProductsService.getManageProductsByIds({ ids: checkedValuesAsStrings })
        .then((response) => {
          setProducts(response);
        })
        .catch((error) => ErrorToast(error));
    } else {
      return;
    }
  }, [checkedValues]);
  return (
    <>
      <div className="card">
        <Helmet>
          <title>{t("manage.products_manage_all")}</title>
        </Helmet>
        <div className="">
          <Stepper step={"ALL"}></Stepper>
          <>
            {product?.id ? (
              <div className="my-3">
                <div className="card-header d-flex align-items-center justify-content-between my-0">
                  <h4 className="card-title mb-0">
                    {t("manage.selected_product")}
                  </h4>
                  <button
                    className="btn btn-secondary ms-2"
                    onClick={(e) => handleSubmit(e)}
                  >
                    {t("global_v2.copy")}
                  </button>
                </div>

                <div className="card-body">
                  <Table className="align-middle table-nowrap ">
                    <thead className="table-light">
                      <tr>
                        <th scope="col">{`${t("global.id")}`}</th>
                        <th scope="col">{`${t("global.aenCode")}`}</th>
                        <th scope="col">{`${t("products.product")}`}</th>
                        <th scope="col">{`${t("products.category")}`}</th>
                        <th scope="col">{`${t("products.createdAt")}`}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr key={product?.id}>
                        <td>
                          <span>#{product?.id}</span>
                        </td>
                        <td>
                          <span className="text-dark">
                            {product?.eanCode ?? "-"}
                          </span>
                        </td>
                        <td>
                          <span className="d-flex justify-content-start">
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0 me-3">
                                <div className="avatar-sm bg-light rounded p-1">
                                  <CustomImageHandler
                                    path={product?.productPictures?.[0]?.path}
                                    alt="Product"
                                    classes="avatar-xs h-100 w-100"
                                  />
                                </div>
                              </div>
                              <div className="flex-grow-1">
                                <h5 className="fs-14 mb-1">
                                  <>{product?.title ?? "-"}</>
                                </h5>
                              </div>
                            </div>
                          </span>
                        </td>

                        <td>
                          {(product?.category as any)?.title ??
                            "Without category"}
                        </td>
                        <td>{formatDate((product as any)?.createdAt)}</td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            ) : (
              <p>{t("manage.no_source_product")}</p>
            )}
          </>
          <>
            <div className="card-header my-0">
              <h4 className="card-title mb-0">
                {t("manage.list_of_products")}
              </h4>
            </div>
            <div className="card-body">
              <Table className="align-middle table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th>{t("global.select")}</th>
                    <th scope="col">{`${t("global.id")}`}</th>
                    <th scope="col">{`${t("global.aenCode")}`}</th>
                    <th scope="col">{`${t("products.product")}`}</th>
                    <th scope="col">{`${t("products.category")}`}</th>
                    <th scope="col">{`${t("products.createdAt")}`}</th>
                  </tr>
                </thead>
                <tbody>
                  {products?.map((product: any) => (
                    <tr key={product?.id}>
                      <td>
                        <input
                          className="form-check-input"
                          type="radio"
                          name="format"
                          id={`flexRadioDefault${product?.id}`}
                          onChange={() => selectChangeHandler(product)}
                        />
                      </td>
                      <td>
                        <span>#{product?.id}</span>
                      </td>
                      <td>
                        <span className="text-dark">
                          {product?.eanCode ?? "-"}
                        </span>
                      </td>
                      <td>
                        <span className="d-flex justify-content-start">
                          <div className="d-flex align-items-center">
                            <div className="flex-shrink-0 me-3">
                              <div className="avatar-sm bg-light rounded p-1">
                                <CustomImageHandler
                                  path={product?.productPictures?.[0]?.path}
                                  alt="Product"
                                  classes="avatar-xs h-100 w-100"
                                />
                              </div>
                            </div>
                            <div className="flex-grow-1">
                              <h5 className="fs-14 mb-1">
                                <>{product?.title ?? "-"}</>
                              </h5>
                            </div>
                          </div>
                        </span>
                      </td>

                      <td>
                        {(product?.category as any)?.title ??
                          "Without category"}
                      </td>
                      <td>{formatDate(product?.createdAt)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </>
        </div>
      </div>
    </>
  );
};
